import { FieldError } from '@/components/ui/field-error';
import { SimpleEditor } from '@/components/tiptap-templates/simple/simple-editor';
import { EVENT_DESCRIPTION_MAX_LENGTH } from '@/lib/types/events.types';
import { eventFormClasses } from '@/lib/utils/events.utils';
import { getEventDescriptionPlainTextFromHtml } from '@/lib/utils/event-description.utils';

type EventDescriptionFieldProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: any;
  forceShowErrors?: boolean;
  externalErrors?: string[];
};

export function EventDescriptionField({
  field,
  forceShowErrors = false,
  externalErrors = [],
}: EventDescriptionFieldProps) {
  const errors =
    externalErrors.length > 0 ? externalErrors : field.state.meta.errors || [];
  const hasErrors = errors.length > 0;
  const showErrors = forceShowErrors || field.state.meta.isTouched;
  const isInvalid = showErrors && hasErrors;
  const plainTextLength = getEventDescriptionPlainTextFromHtml(
    field.state.value
  ).length;

  return (
    <div className="space-y-2">
      <label className={eventFormClasses.label} htmlFor={field.name}>
        Description
      </label>
      <SimpleEditor
        value={field.state.value ?? ''}
        onChange={(nextValue) => field.handleChange(nextValue)}
        onBlur={field.handleBlur}
        placeholder="Agenda, speakers, and anything attendees should prep."
        inputId={field.name}
        invalid={isInvalid}
      />
      <div className="flex justify-between text-sm text-muted-foreground">
        <span>Share enough context for attendees.</span>
        <span>
          {plainTextLength}/{EVENT_DESCRIPTION_MAX_LENGTH}
        </span>
      </div>
      {showErrors && <FieldError errors={errors} />}
    </div>
  );
}
